import React, {useState, useEffect} from 'react';
import {
  Grid,
  Column,
  DataTable,
  TableContainer,
  Table,
  TableHead,
  Button,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Theme,
} from '@carbon/react';
import { getResoucesForViews } from '../../services/services';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";

const headers = [
  {
    key: 'name',
    header: 'Name',
  },
  {
    key: 'empnmb',
    header: 'Employee Number',
  },
  {
    key: 'notesid',
    header: 'Notes ID',
  },
  {
    key: 'ctrycode',
    header: 'Country',
  }
];

const ApproversList = () => {
  const navigate = useNavigate();

  const goHomeScreen = () => {
    navigate('/home')
  };

  const getApproversList = async (request) => await getResoucesForViews(request)
    .then(response => {      
      if(response.status === 200){
        response.json()
          .then(response => {
            console.log(response);
            parserIdInResponse(response);
          })
      }    
    })

  useEffect(() => {
    const request = {};
    request.viewName = 'approverList'
    getApproversList(request);    
  },[0])

  const [rows, setRows] = useState([]);

  const parserIdInResponse = (response) => {
    const resParsed = response.lNameAuthorized.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["name"] = res.name;
      parsed["empnmb"] = res.number;
      parsed["notesid"] = res.notesid;
      parsed["ctrycode"] = res.ctrycode;
      return parsed;
    });
    setRows(resParsed);
  }

  return (
    <>
      <h2 className="table-title">Approver's List</h2>

      <Grid>
        <Theme theme="g90">
            <CommodityHeader />
        </Theme>
        <Column lg={16} >
        <Button className='style-bttbackID' size="lg" onClick={goHomeScreen}>Back to Home</Button>
          <DataTable
            isSortable={true}
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              getSelectionProps,
              onInputChange
            }) => (
              <TableContainer>

                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                    {/* pass in `onInputChange` change here to make filtering work */}
                  </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>
                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map(row => (

                      <TableRow {...getRowProps({ row })}>

                        {row.cells.map(cell => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>


                        ))}


                      </TableRow>


                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          />
        </Column>
      </Grid>

    </>
  );
};

export default ApproversList;